import * as _ from 'underscore';
import { Module } from '../Module';

export enum AngularKeys {
  Tab = 9,
  Enter = 13,
  Escape = 27,
  Space = 32,
}

_.each(_.filter(<any>AngularKeys, _.isString), (key: string) => {
    Module.instance().directive('tb' + key, <any[]>[
      () => {
        return {
          link: (scope: ng.IScope, element: JQuery, attrs: any) => {
            element.on('keydown', (event: JQuery.Event) => {
              if (event.which === (<any>AngularKeys)[key]) {
                scope.$apply(() => {
                  scope.$eval(attrs['tb' + key], { $event: event });
                });
              }
            });
          }
        };
      }
    ]);
  }
);
